// Sedi note di CIL (valori dell'enum `Location` di Strapi) con indirizzo.
// I comuni senza indirizzo preciso mostrano solo il nome del luogo.
const EVENT_LOCATIONS = {
  'CIL House': {
    title: 'CIL House',
    subtitle: 'Sede CIL',
    address: 'Via Carlo Alberto 7, 10023 Chieri (TO)',
  },
  Munlab: {
    title: 'Munlab',
    address: 'Via Camporelle 50, Cambiano (TO)',
  },
  'Associazione DAI': {
    title: 'Associazione DAI',
    address: 'Via Brignole 34, 10026 Santena (TO)',
  },
  ExMattatoio: {
    title: 'ExMattatoio',
    address: 'Via Papa Giovanni XXIII 8B, 10023 Chieri (TO)',
  },
  Arka: {
    title: 'Arka',
    address: 'Piazza Vincenzo Caselli 19, 10023 Chieri (TO)',
  },
  Online: {
    title: 'Online',
    note: 'Evento online: il link per partecipare ti verrà inviato dopo l’iscrizione.',
  },
  'Da definire': {
    title: 'Luogo da definire',
    note: 'Il luogo verrà comunicato a breve.',
  },
  Altro: {
    title: 'Altro luogo',
    note: 'Il luogo è indicato nella descrizione dell’evento.',
  },
};

export const getEventLocation = (location) => {
  if (!location) return null;
  return EVENT_LOCATIONS[location] || { title: location };
};

export const getMapsUrl = (address) =>
  address
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
    : null;
